module.exports = __webpack_public_path__ + "static/media/sd.8f0ac64a.svg";